export default __webpack_public_path__ + "static/touching-3df268a3e6afdad1791291a055f0f15f.png";